module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Ultralight.8bdc02a6.woff";